import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import star from "../../../assets/images/pendingIcons/star.png";
import noImage from "../../../assets/images/settings/no-image.png";
import AssignedGroupJuries from "../../Admin/Home/Pages/AdminAudition/AdminRequestForApproval/AssignedGroupJuries";
import "./PostContentMaking.css";
import useFileHandleS3 from "../../../CustomHooks/useFileHandleS3";
import useVdieoHandleS3 from "../../../CustomHooks/useVideoHandleS3";
import MediaUploadProgressBar from "../../../Screen/MediaUploadProgressBar";
import useVideoHandleWithCompress from "../../../CustomHooks/useVideoHandleWithCompress";

const CreatePost = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);


  const [loading, setLoading] = useState(false);
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [events, setEvents] = useState([]);
  const [audition_id, setAuditionId] = useState("");
  const [convertedContent, setConvertedContent] = useState(null);
  const [instructionContent, setInstructionContent] = useState(null);
  const [fees, setFees] = useState(0);
  const [errorList, setErrorList] = useState([]);
  const history = useHistory();
  const [regStartDate, setRegStartDate] = useState(null);
  const [regEndDate, setRegEndDate] = useState(null);

  const [judge, setJudge] = useState([]);
  const [juryGroups, setJuryGroups] = useState([]);

  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'audition/images',delKey);

  // Video File Handle
  const videoInputRef = useRef(null);
  const [videoPath, setVideoPath] = useState("");
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'audition/videos', videoDelKey);


  useEffect(() => {
    axios.get(`/api/audition-admin/audition/events`).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        setEvents(res.data.events);
      }
    });
  }, []);

  const handleImageChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };
  const deleteFile = ()=>
  {
    setFile(null);
    setDelKey(fileKey);
    fileInputRef.current.value = '';
  }
  const handleVideoChange = (file) => {
    setVideoDelKey(videoKey);
    setVideo('');
    setVideo(file[0]);
  };
  const deleteVideo = () => {
    setVideo('');
    setVideoDelKey(videoKey);
    videoInputRef.current.value = '';
  }

  const handleChange = (e) => {
    setAuditionId(e.target.value);

    const results = events.filter((obj) => {
      return obj.id == e.target.value;
    });
    var audition_slug = results[0];

    axios
      .get(`/api/audition-admin/audition-event/for-create-post/${audition_slug?.slug}`)
      .then((res) => {
        if (res.data.status === 200) {
          var audition = res.data.event;
          setJudge(res?.data?.event?.assigned_judges);

          setJuryGroups(res?.data?.juryGroups);

          setConvertedContent(audition?.description);
          setInstructionContent(audition?.instruction);

          setVideoPath(audition?.video?audition?.video:'');
          setFilePath(audition?.banner?audition?.banner:'');
          if (audition?.fees != "null") {
            setFees(audition?.fees);
          }

          if (audition?.info?.registration_start_date != null) {
            setRegStartDate(audition?.info?.registration_start_date);
          }

          if (audition?.info?.registration_end_date != null) {
            setRegEndDate(audition?.info?.registration_end_date);
          }
        }
      });
  };

  const handleFeesInput = (e) => {
    setFees(Number(e.target.value));
  };


  const submitPostMakingContent = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();
    fData.append("audition_id", audition_id);
    fData.append("instruction", instructionContent);
    fData.append("description", convertedContent);
    fData.append("user_reg_start_date", regStartDate);
    fData.append("user_reg_end_date", regEndDate);
    fData.append("video", videoKey ? videoKey: videoPath);
    fData.append("image", fileKey?fileKey:filePath);
    fData.append("fees", fees);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/post-content/store`, fData)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 200) {

            if(file){
              setFile('');
              setDelKey(filePath.split("com/").pop())
            }
            if (video) {
              setVideo('');
              setVideoDelKey(videoPath.split("com/").pop())
            }

            swal("Success", res.data.message, "success");
            // history.goBack();

            history.push("/audition-admin/audition/post-list");
          }

          if (res.data.status == 422) {
            setErrorList(res.data.validation_errors);
          }

          if (res.data.status === 49) {
            swal("Error", res.data.message, "error");
          }
          if (res.data.status === 410) {
            swal("Take Rest", res.data.message, "Already Post live");
          }
        });
    });
  };

  return (
    <>
      <div className="card card-bg head-line  mb-2  mb-2">
        <div className="text-light d-flex justify-content-center p-2">
          <div className="faTrophy">
            <i className="fas fa-trophy"></i>
          </div>
          <h4 className="mx-3 fw-bold text-white p-2">
            Content Making Requirements for Star
          </h4>
        </div>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  onSubmit={submitPostMakingContent}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="row">
                    <div className="form-group row mt-3">
                      <label
                        for="staticEmail"
                        className="col-sm-3 label-text fw-bold"
                      >
                        Select An Audition
                      </label>
                      <div className="col-sm-9">
                        <select
                          onChange={handleChange}
                          className="form-select form-control reply-control text-black"
                          aria-label="Default select example"
                          id="audition_id"
                          name="audition_id"
                        >
                          <option value="0">--Select Audition--</option>
                          {events.map((event, index) => (
                            <option key={index} value={event.id}>
                              {event.title}
                            </option>
                          ))}
                        </select>
                        <span className="text-danger">
                          {errorList.audition_id}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-3 label-text fw-bold"
                      >
                        Instruction
                      </label>
                      <div className="col-sm-9">
                        <CKEditor
                          editor={ClassicEditor}
                          data={instructionContent}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setInstructionContent(data);
                          }}
                          onBlur={(event, editor) => {}}
                          onFocus={(event, editor) => {}}
                        />
                        <span className="text-danger">
                          {errorList.instruction}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-3 label-text fw-bold"
                      >
                        Description
                      </label>
                      <div className="col-sm-9">
                        <CKEditor
                          editor={ClassicEditor}
                          data={convertedContent}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setConvertedContent(data);
                          }}
                          onBlur={(event, editor) => {}}
                          onFocus={(event, editor) => {}}
                        />
                        <span className="text-danger">
                          {errorList.description}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-4">
                      <label
                        for="staticEmail"
                        className="col-sm-3 label-text fw-bold"
                      >
                        Fees
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control reply-control"
                          placeholder="Enter fee $"
                          onChange={handleFeesInput}
                          name="fees"
                          value={fees}
                          step=".01"
                          min="0"
                        />
                        <span className="text-danger">{errorList.fees}</span>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6 row">
                        <div className="col-md-6">
                          <label
                            for="staticEmail"
                            className="label-text fw-bold"
                          >
                            Upload Video
                          </label>
                        </div>
                        <div className="col-md-6">
                        {videoUrl && video ? (
                        <div className="position-relative">
                          <ReactPlayer
                            url={videoUrl}
                            controls
                            playing={false}
                            volume={1}
                            width="100%"
                            height="200px" // style={{ margin: "0 auto" }}
                          />
                          <span className="text-warning right-cross-button" onClick={deleteVideo}>X</span>
                        </div>
                          ) : <ReactPlayer
                          url={videoCdnUrl + videoPath}
                          controls
                          playing={false}
                          volume={1}
                          width="100%"
                          height="200px" // style={{ margin: "0 auto" }}
                          />}
                          <input
                            type="file"
                            name="file"
                            id="setFile"
                            className="inputfile w-25"
                            accept="video/mp4"
                            onChange={(e) => handleVideoChange(e.target.files)}
                            ref={videoInputRef}
                          />
                          {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                          <label for="setFile">
                            <i className="fas fa-cloud-upload-alt"></i> Upload
                            Video
                          </label>
                          <span className="text-danger">{errorList.video}</span>
                        </div>
                      </div>

                      <div className="col-md-6 my-2 row">
                        <label
                          for="staticEmail"
                          className="col-md-6 label-text fw-bold text-md-end"
                        >
                          Upload Banner
                        </label>

                        <div className="col-md-6">
                        {fileUrl && file ? (
                          <div className="position-relative">

                            <img
                            src={fileUrl}
                            className="img-fluid avatar-img-src"
                            alt=""
                            style={{ maxHeight: "300px" }}
                          />
                          <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                          </div>
                        ) : (
                          <img
                            src={imageCdnUrl + filePath}
                            className="img-fluid avatar-img-src"
                            alt=""
                            style={{ maxHeight: "300px" }}
                          />
                        )}
                          <input
                            type="file"
                            name="imageFile"
                            id="imageFile"
                            className="inputfile w-25"
                            accept="image/jpg,image/jpeg, image/png"
                            onChange={(e) => handleImageChange(e.target.files)}
                            ref={fileInputRef}
                          />
                          {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                          <label for="imageFile">
                            <i className="fas fa-cloud-upload-alt"></i> Upload
                            Banner
                          </label>
                          <span className="text-danger">{errorList.image}</span>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-md-6 my-2 row">
                        <label
                          for="staticEmail"
                          className="col-md-6 label-text fw-bold"
                        >
                          Registration Start Date
                        </label>
                        <div className="col-md-6">
                          <input
                            readOnly
                            type="date"
                            className="form-control reply-control"
                            name="registration_start_date"
                            value={regStartDate}
                          />
                          {errorList.reg_start_date}
                        </div>
                      </div>

                      <div className="col-md-6 my-2 row">
                        <label
                          for="staticEmail"
                          className="col-md-6 label-text fw-bold text-md-end"
                        >
                          Registration End Date
                        </label>

                        <div className="col-md-6">
                          <input
                            readOnly
                            type="date"
                            className="form-control reply-control "
                            name="registration_end_date"
                            value={regEndDate}
                          />
                          {errorList.reg_end_date}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-5">
                    <div className="card card-bg head-line mt-2 mb-2">
                      <div className="text-light p-1">
                        <h6 className="mx-3 text-white fw-bolder text-center p-2">
                          Judge Panel
                        </h6>
                      </div>
                    </div>

                    <div className="row mt-4 justify-content-center ">
                      <div className="col-sm-12 col-md-6 col-lg-4 mb-2 ">
                        <div className="card card-bg-black-body p-3">
                          <h4 className="judge-panel-x d-flex justify-content-center text-center p-2 text-light mb-3">
                            <img src={star} alt="" />
                            &nbsp; Star Panel
                          </h4>
                          {judge &&
                            judge.map((judge) => (
                              <div className="d-flex star-div bg-dark align-items-center p-2 mb-2">
                                <div className="img-x-div">
                                  <img
                                    src={
                                      judge.user?.image
                                        ? imageCdnUrl + judge.user?.image
                                        : noImage
                                    }
                                    alt=""
                                    className="star-x-div-img"
                                  />
                                </div>
                                <div className="img-x-div">
                                  <h5 className="text-warning fw-bold px-3">
                                    {judge.user?.first_name +
                                      " " +
                                      judge.user?.last_name}
                                  </h5>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-6 col-lg-4 mb-2 ">
                        <div className="card card-bg-black-body p-3">
                          <h4 className="judge-panel-x d-flex justify-content-center text-center p-2 text-light mb-3">
                            <img src={star} alt="" />
                            &nbsp; Admin Panel
                          </h4>
                          {judge &&
                            judge.map((judge) => (
                              <div className="d-flex bg-dark star-div align-items-center p-2 mb-2">
                                <div className="img-x-div">
                                  <img
                                    src={
                                      judge?.admin?.image
                                        ? imageCdnUrl + judge?.admin?.image
                                        : noImage
                                    }
                                    alt=""
                                    className="star-x-div-img"
                                  />
                                </div>
                                <div className="img-x-div">
                                  <h5 className="text-warning fw-bold px-3">
                                    {judge?.admin?.first_name ? judge?.admin?.first_name : ' ' +
                                      " " +
                                      judge?.admin?.last_name ? judge?.admin?.last_name : ' '}
                                  </h5>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="card card-bg head-line mt-2 mb-2">
                      <div className="text-light">
                        <h6 className="mx-3 text-white fw-bolder text-center p-2">
                          Jury Boards
                        </h6>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center ">
                      {juryGroups &&
                        juryGroups.map((group) => (
                          <>
                            <div className="col-sm-12 col-md-6 col-lg-4 mb-2 ">
                              <div className="card card-bg-black-body p-3">
                                {/* <h4 className="judge-panel-x-z text-center p-2 text-black mb-3 fw-bold">
                                      {group.name}
                                    </h4> */}
                                <h4 className="judge-panel-x d-flex justify-content-center text-center p-2 text-light mb-3">
                                  <img src={star} alt="" />
                                  &nbsp; {group.name}
                                </h4>
                                <div className="juryFeaturedBlack text-center">
                                  <AssignedGroupJuries
                                    audition_id={audition_id && audition_id}
                                    group={group.id}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-12 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Confirm
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatePost;
